import { BASE_ROUTE } from '../base';
import { RouterPayload } from '../route.types';
import { FormSubmissionV2RoutePayload, FormSubmissionV2RouteQueryParams } from './form-submission-route.type';
import { BASE_SUBMISSION_V2_ROUTE } from './form-submission.constant';

export interface FormsSubmissionV2InboxRoutePayload {
  relativePath?: boolean /** kept this because we will need it when we will do the sub routing in the inbox category */;
}

export function getFormSubmissionV2Route(payload: FormSubmissionV2RoutePayload): RouterPayload {
  const { relativePath = false, locationId, submissionId } = payload;
  const searchParams: FormSubmissionV2RouteQueryParams = {
    list: payload.listType,
  };

  if (payload.listType === 'inbox') {
    searchParams.subCategory = payload.subCategory || 'all';
  }

  if (submissionId) {
    searchParams.submissionId = submissionId;
  }

  if (locationId) {
    searchParams.locationId = locationId;
  }

  return {
    to: relativePath ? BASE_SUBMISSION_V2_ROUTE.split(BASE_ROUTE)[1] : BASE_SUBMISSION_V2_ROUTE,
    /**
     * Cast to Record<string, string> to match the expected type
     * This is a workaround to avoid TypeScript error
     */
    search: searchParams as unknown as Record<string, string>,
  };
}
